import Experience from "./Experience/Experience.js";

const experience = new Experience(document.querySelector("canvas.webgl"));

// UI Elements
const overlay = document.getElementById("loading-overlay");
const loadingBar = document.getElementById("loading-bar");
const loadingBarContainer = document.querySelector(".loading-bar-container");
const enterButton = document.getElementById("enter-button");
const audioToggle = document.getElementById("audio-toggle");

const audioTargetVolume = 0.4;
const audioFadeDurationMs = 1200;
let audioFadeFrame = null;

// Update loading bar
experience.resources.on("progress", (progressRatio) => {
    loadingBar.style.width = `${progressRatio * 100}%`;
});

// Loading complete
experience.resources.on("ready", () => {
    enterButton.classList.add("is-visible");
});

// Enter experience
enterButton.addEventListener("click", () => {
    // Hide overlay
    overlay.classList.add("hidden");

    if (audioToggle) {
        window.setTimeout(() => {
            audioToggle.classList.add("is-visible");
        }, 350);
    }

    playAudioWithFade();
});

// Background audio
// Stored on window so other modules can access/control it if needed
window.__backgroundAudio = new Audio(
    `${import.meta.env.BASE_URL}underwaterLoop.mp3`,
);
window.__backgroundAudio.loop = true;
window.__backgroundAudio.preload = "auto";
window.__backgroundAudio.volume = 0;

function cancelAudioFade() {
    if (audioFadeFrame !== null) {
        window.cancelAnimationFrame(audioFadeFrame);
        audioFadeFrame = null;
    }
}

function fadeAudioTo(targetVolume, { pauseOnComplete = false } = {}) {
    const audio = window.__backgroundAudio;
    const startVolume = audio.volume;
    const startTime = performance.now();

    cancelAudioFade();

    return new Promise((resolve) => {
        const step = (currentTime) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / audioFadeDurationMs, 1);
            audio.volume =
                startVolume + (targetVolume - startVolume) * progress;

            if (progress < 1) {
                audioFadeFrame = window.requestAnimationFrame(step);
                return;
            }

            audio.volume = targetVolume;
            audioFadeFrame = null;

            if (pauseOnComplete) {
                audio.pause();
                audio.currentTime = audio.currentTime;
            }

            resolve();
        };

        audioFadeFrame = window.requestAnimationFrame(step);
    });
}

function playAudioWithFade() {
    const audio = window.__backgroundAudio;

    if (!audio.paused) {
        setToggleState(true);
        return fadeAudioTo(audioTargetVolume);
    }

    audio.volume = 0;
    return audio
        .play()
        .then(() => {
            setToggleState(true);
            return fadeAudioTo(audioTargetVolume);
        })
        .catch((err) => {
            console.warn("Background audio play failed:", err);
        });
}

function pauseAudioWithFade() {
    setToggleState(false);
    return fadeAudioTo(0, { pauseOnComplete: true });
}

function setToggleState(isPlaying) {
    if (!audioToggle) return;
    if (isPlaying) {
        audioToggle.classList.add("playing");
        audioToggle.setAttribute("aria-pressed", "true");
        audioToggle.title = "Pause audio";
        audioToggle.setAttribute("aria-label", "Pause background audio");
    } else {
        audioToggle.classList.remove("playing");
        audioToggle.setAttribute("aria-pressed", "false");
        audioToggle.title = "Play audio";
        audioToggle.setAttribute("aria-label", "Play background audio");
    }
}

if (audioToggle) {
    audioToggle.addEventListener("click", (e) => {
        e.stopPropagation();
        if (window.__backgroundAudio.paused) {
            playAudioWithFade();
        } else {
            pauseAudioWithFade();
        }
    });

    // Reflect audio state if playback changes externally
    window.__backgroundAudio.addEventListener("play", () =>
        setToggleState(true),
    );
    window.__backgroundAudio.addEventListener("pause", () =>
        setToggleState(false),
    );
}

setToggleState(false);
